module.exports = __webpack_public_path__ + "static/menu-Art-4ea195cc5eaaa83a738d27c505e53310.png";